import React, { useEffect, createElement } from 'react';
import { StarIcon, TrendingUpIcon, GiftIcon, CheckIcon } from 'lucide-react';
import { CTAButton } from './components/CTAButton';
import { TestimonialCard } from './components/TestimonialCard';
import { TrustBadge } from './components/TrustBadge';
import { StickyProductCard } from './components/StickyProductCard';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    ;
    (function (f: any, b: any, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e);
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
    // Initialize Facebook Pixel
    ;
    (window as any).fbq('init', '800724402946354');
    (window as any).fbq('track', 'PageView');
    // Add noscript fallback image
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=800724402946354&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      {/* Header - Dark Banner with Beauty News Logo and US Flag */}
      <header className="bg-gray-800 border-b border-gray-700 shadow-sm" data-id="element-1">
        <div className="max-w-7xl mx-auto px-4 py-3" data-id="element-2">
          <div className="flex items-center justify-between" data-id="element-3">
            {/* Beauty News Logo */}
            <div className="flex items-center gap-2" data-id="element-4">
              <svg className="w-8 h-8 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-5">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="currentColor" data-id="element-6" />
                <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" fill="currentColor" data-id="element-7" />
              </svg>
              <div className="flex flex-col" data-id="element-8">
                <span className="text-white font-bold text-sm leading-tight" data-id="element-9">
                  beauty
                </span>
                <span className="text-white font-bold text-sm leading-tight" data-id="element-10">
                  news
                </span>
              </div>
            </div>

            {/* Trending in the US Badge */}
            <div className="flex items-center gap-2 bg-gray-700 px-4 py-2 rounded-full" data-id="element-11">
              <span className="text-2xl" data-id="element-12">🇺🇸</span>
              <span className="text-white font-semibold text-sm" data-id="element-13">
                Trending in the US
              </span>
            </div>
          </div>
        </div>
      </header>

      {/* Rating Banner */}

      {/* Limited Time Offer Banner */}

      {/* Breadcrumb */}
      <div className="max-w-7xl mx-auto px-4 py-3" data-id="element-14">
        <p className="text-sm text-gray-500" data-id="element-15">
          Home &gt; Anti-Aging &gt;{' '}
          <strong data-id="element-16">Korean Silk Peptide Technology</strong>
        </p>
      </div>

      {/* Main Content with Sidebar Layout */}
      <div className="max-w-7xl mx-auto px-4 py-8" data-id="element-17">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-18">
          {/* Main Content - Left Side */}
          <main className="lg:col-span-8" data-id="element-19">
            {/* Hero Section */}
            <section className="mb-12" data-id="element-20">
              <h2 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight mb-6" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-21">
                Korean Skin Science Researcher & Founder of Reliq:
              </h2>
              <h3 className="text-2xl md:text-4xl font-bold text-gray-900 leading-tight mb-6" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-22">
                This Is the Most Effective Way To Lift Sagging Skin and Erase
                Deep Wrinkles—Without Retinol Damage, Botox Needles, or Feeling
                Invisible Anymore
              </h3>
              <p className="text-xl text-gray-700 mb-8 italic" data-id="element-23">
                Even if retinol destroyed your skin... even if expensive creams
                have done nothing... even if you've given up hope...
              </p>

              {/* Expert Byline */}
              <div className="bg-white rounded-xl shadow-lg p-6 mb-8 border border-gray-200" data-id="element-24">
                <div className="flex items-start gap-4" data-id="element-25">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9MaiRtwtzW3QQQ3Ywdtpf3/sarah_Kim_.png" alt="Dr. Sarah Kim" className="w-20 h-20 rounded-full object-cover flex-shrink-0" data-id="element-26" />
                  <div data-id="element-27">
                    <h4 className="font-bold text-lg text-gray-900" data-id="element-28">
                      Dr. Sarah Kim
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-29">
                      Board-Certified Dermatology Consultant
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-30">
                      Seoul National University | 15+ Years Experience
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-31">
                      Updated: November 2024
                    </p>
                  </div>
                </div>
              </div>

              {/* Hero Product Image */}
              <div className="bg-gradient-to-br from-pink-100 to-amber-50 rounded-xl overflow-hidden mb-8" data-id="element-32">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tNF8iUT5S9KEzqerixkxdJ/make_sense.png" alt="Before and After - Silk Lifting Peptide Ampoule Results" className="w-full h-auto" data-id="element-33" />
              </div>
            </section>

            {/* Problem Identification */}
            <section className="mb-12" data-id="element-34">
              <h3 className="text-3xl font-bold text-gray-900 mb-6" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-35">
                When Women With Sensitive Skin Tell Me They've Tried
                Everything—I Know Exactly What They Mean
              </h3>

              <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-36">
                Hello, I'm Dr. Sarah Kim.
              </p>

              <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-37">
                I'm a board-certified dermatology consultant who spent 15 years
                studying Korean skin science at Seoul National University,
                specializing in barrier-protective anti-aging treatments.
              </p>

              <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-38">
                And I'm going to let you in on a secret the Western beauty
                industry doesn't want you to know...
              </p>

              <div className="bg-pink-50 border-l-4 border-pink-500 p-6 rounded-r-lg mb-8" data-id="element-39">
                <p className="text-xl font-bold text-gray-900" data-id="element-40">
                  You CAN achieve visible lifting and firming results—even with
                  the most sensitive, reactive, retinol-damaged skin.
                </p>
              </div>

              <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-41">
                But first, let me tell you why I'm so passionate about this.
              </p>
            </section>

            {/* "I've Tried Everything" Section */}
            <section className="mb-12" data-id="element-42">
              <h3 className="text-3xl font-bold text-gray-900 mb-6" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-43">
                "I've Tried EVERYTHING—And Nothing Works."
              </h3>

              <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-44">
                When women 45-60 with sensitive skin come to me complaining
                about sagging jawlines, jowls, deep wrinkles, and feeling
                invisible, they always say the same thing:
              </p>

              <p className="text-xl font-bold text-gray-900 mb-4 italic" data-id="element-45">
                "I've tried EVERYTHING—retinol destroyed my skin, expensive
                creams do nothing, and Botox terrifies me. Nothing works."
              </p>

              <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-46">
                I get it. You're not alone.
              </p>

              <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-47">
                In fact, you're one of millions of women who've been told you
                can't have real anti-aging results because of your sensitive
                skin.
              </p>

              <div className="bg-gray-50 rounded-lg p-6 mb-8" data-id="element-48">
                <p className="text-lg text-gray-700 mb-4" data-id="element-49">
                  You've been told to just "accept aging gracefully."
                </p>
                <p className="text-lg text-gray-700 mb-4" data-id="element-50">
                  You've been told your only options are:
                </p>
                <ul className="space-y-3 ml-6" data-id="element-51">
                  <li className="text-lg text-gray-700 flex items-start gap-2" data-id="element-52">
                    <span className="text-red-500 font-bold" data-id="element-53">✗</span>
                    <span data-id="element-54">
                      Suffer through retinol (and watch your skin get thinner,
                      redder, more damaged)
                    </span>
                  </li>
                  <li className="text-lg text-gray-700 flex items-start gap-2" data-id="element-55">
                    <span className="text-red-500 font-bold" data-id="element-56">✗</span>
                    <span data-id="element-57">Spend $700+ every 3 months on Botox forever</span>
                  </li>
                  <li className="text-lg text-gray-700 flex items-start gap-2" data-id="element-58">
                    <span className="text-red-500 font-bold" data-id="element-59">✗</span>
                    <span data-id="element-60">
                      Accept that sagging, invisible feeling as your new reality
                    </span>
                  </li>
                </ul>
              </div>

              <p className="text-xl font-bold text-gray-900 mb-4" data-id="element-61">
                But what if I told you there's a third option?
              </p>

              <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-62">
                One that Korean women have been using for years to maintain
                lifted, firm, radiant skin well into their 60s—without a single
                Botox needle or drop of retinol.
              </p>
            </section>

            {/* 5 Hidden Reasons */}
            <section className="mb-12" data-id="element-63">
              <h3 className="text-3xl font-bold text-gray-900 mb-8" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-64">
                Here Are The 5 Hidden Reasons Your Skin Keeps Sagging (No Matter
                What You Try)
              </h3>

              <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-65">
                Before I reveal the solution, you need to understand WHY your
                skin is sagging—and why everything you've tried has failed.
              </p>

              <div className="space-y-8" data-id="element-66">
                {/* Reason 1 */}
                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200" data-id="element-67">
                  <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-68">
                    🔬 Reason #1: Collagen Loss Accelerates After 45
                  </h4>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-69">
                    Your body produces 1% less collagen each year after age 40.
                  </p>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-70">
                    By 50, you've lost nearly 30% of your skin's structural
                    support—the invisible scaffolding that keeps your face
                    lifted and firm.
                  </p>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-71">
                    That's why your jawline softens into jowls. Why deep lines
                    carve from your nose to your mouth. Why your neck gets
                    crepey.
                  </p>
                  <p className="text-gray-700 font-semibold" data-id="element-72">
                    You're not imagining it. Your skin is literally losing the
                    structure that holds it up.
                  </p>
                </div>

                {/* Reason 2 */}
                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200" data-id="element-73">
                  <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-74">
                    🧪 Reason #2: Retinol Destroys Your Barrier (Especially for
                    Sensitive Skin)
                  </h4>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-75">
                    The beauty industry calls retinol the "gold standard" of
                    anti-aging.
                  </p>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-76">
                    But here's what they don't tell you:
                  </p>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-77">
                    Retinol works by damaging your skin barrier to force cell
                    turnover. It destroys filaggrin—your skin's "scaffolding
                    protein"—the very thing that keeps skin firm and resilient.
                  </p>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-78">
                    This creates what researchers call "inflammaging"—chronic
                    inflammation that makes you age FASTER, not slower.
                  </p>
                  <p className="text-gray-700 font-semibold" data-id="element-79">
                    For sensitive skin? It's a disaster. Burning, peeling,
                    redness, thinning. Your skin gets weaker with every
                    application.
                  </p>
                </div>

                {/* Reason 3 */}
                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200" data-id="element-80">
                  <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-81">
                    💰 Reason #3: Expensive Creams Only Hydrate the Surface
                  </h4>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-82">
                    La Mer. Augustinus Bader. SK-II.
                  </p>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-83">
                    $200+ per jar. Beautiful packaging. Luxurious textures.
                  </p>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-84">
                    And they deliver... hydration. That's it.
                  </p>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-85">
                    Zero lifting. Zero firming. Zero structural change.
                  </p>
                  <p className="text-gray-700 font-semibold" data-id="element-86">
                    You're paying for marketing and packaging—not results.
                  </p>
                </div>

                {/* Reason 4 */}
                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200" data-id="element-87">
                  <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-88">
                    💉 Reason #4: Botox Addresses Expression Lines—Not
                    Structural Sagging
                  </h4>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-89">
                    Botox paralyzes muscles to smooth expression lines on your
                    forehead and around your eyes.
                  </p>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-90">
                    But it does NOTHING for: Sagging jawline, jowls, deep
                    nasolabial folds, crepey neck skin, loss of facial volume.
                  </p>
                  <p className="text-gray-700 font-semibold" data-id="element-91">
                    Plus: $700 per session, every 3-4 months, forever. That's
                    $2,800+ per year.
                  </p>
                </div>

                {/* Reason 5 */}
                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200" data-id="element-92">
                  <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-93">
                    😔 Reason #5: The Emotional Toll Compounds Physical Aging
                  </h4>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-94">
                    Here's what nobody talks about:
                  </p>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-95">
                    Feeling invisible creates stress hormones (cortisol) that
                    accelerate collagen breakdown—creating a vicious cycle.
                  </p>
                  <p className="text-gray-700 font-semibold" data-id="element-96">
                    The emotional toll isn't separate from the physical aging.
                    It's making it worse.
                  </p>
                </div>
              </div>
            </section>

            {/* CTA 1 */}
            <div className="text-center my-12" data-id="element-97">
              <CTAButton size="large" data-id="element-98">
                👉 GET UP TO 71% OFF SILK LIFTING AMPOULE NOW
              </CTAButton>
            </div>

            {/* Before/After Visual */}
            <section className="mb-12" data-id="element-99">
              <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-100">
                The Real Cost Isn't Just What You See in The Mirror
              </h3>

              <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-101">
                <div className="bg-gray-100 rounded-lg p-6 text-center" data-id="element-102">
                  <h4 className="font-bold text-lg mb-3 text-gray-900" data-id="element-103">
                    BEFORE
                  </h4>
                  <div className="w-full h-48 rounded-lg mb-4 overflow-hidden" data-id="element-104">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aKB7zMbF28HiyGqZz7oiah/before_silk.png" alt="Before using Silk Lifting Peptide Ampoule" className="w-full h-full object-cover" data-id="element-105" />
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-106">
                    Avoiding mirrors. Canceling plans. Feeling invisible to your
                    own partner.
                  </p>
                </div>
                <div className="bg-yellow-50 rounded-lg p-6 text-center" data-id="element-107">
                  <h4 className="font-bold text-lg mb-3 text-gray-900" data-id="element-108">
                    DURING
                  </h4>
                  <div className="w-full h-48 rounded-lg mb-4 overflow-hidden" data-id="element-109">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bMcZaeaDwss23FDhybLp6c/during_silk.png" alt="During treatment with Silk Lifting Peptide Ampoule" className="w-full h-full object-cover" data-id="element-110" />
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-111">
                    Trying endless products. Hope fading with each failed
                    attempt.
                  </p>
                </div>
                <div className="bg-green-50 rounded-lg p-6 text-center" data-id="element-112">
                  <h4 className="font-bold text-lg mb-3 text-gray-900" data-id="element-113">
                    AFTER
                  </h4>
                  <div className="w-full h-48 rounded-lg mb-4 overflow-hidden" data-id="element-114">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mMchLsHA3SZZUuUWEu8qJm/after_silk.png" alt="After using Silk Lifting Peptide Ampoule" className="w-full h-full object-cover" data-id="element-115" />
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-116">
                    Seeing your lifted jawline. Feeling SEEN again. Being
                    BEAUTIFUL at 55, 60, 65+.
                  </p>
                </div>
              </div>
            </section>

            {/* What You Really Want */}
            <section className="mb-12" data-id="element-117">
              <h3 className="text-3xl font-bold text-gray-900 mb-6" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-118">
                What You Really Want (And Why Current Solutions Fall Short)
              </h3>

              <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-119">
                Let me guess what you're really hoping for:
              </p>

              <div className="bg-pink-50 rounded-lg p-6 mb-6 space-y-4" data-id="element-120">
                <p className="text-lg text-gray-900 font-semibold" data-id="element-121">
                  You don't just want firmer skin—you want to feel SEEN again.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-122">
                  You want to catch your partner's eye across the room like you
                  did 20 years ago. You want him to grab your hand in public,
                  whisper in your ear at parties, look at you with desire
                  instead of indifference.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-123">
                  You want to walk into a restaurant and get that warm eye
                  contact from strangers again.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-124">
                  You want to look in the mirror and recognize yourself.
                </p>
              </div>

              <p className="text-xl font-bold text-gray-900 mb-8" data-id="element-125">
                Am I right?
              </p>
            </section>

            {/* The Night Everything Changed */}
            <section className="mb-12" data-id="element-126">
              <h3 className="text-3xl font-bold text-gray-900 mb-6" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-127">
                The Night Everything Changed For Me (And Why I Founded Reliq)
              </h3>

              <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-128">
                One night, I was reviewing clinical trials from Seoul National
                University's dermatology research lab.
              </p>

              <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-129">
                I was looking for solutions for my patients—women just like you
                who'd been told they couldn't have real results because of their
                sensitive skin.
              </p>

              <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-130">
                And something clicked.
              </p>

              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-lg mb-6" data-id="element-131">
                <p className="text-xl font-bold text-gray-900" data-id="element-132">
                  Why do Korean women in their 50s and 60s have dramatically
                  firmer, more lifted skin than Western women—without Botox or
                  retinol?
                </p>
              </div>

              <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-133">
                I dove deeper into the research.
              </p>

              <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-134">
                The answer was right there in the clinical data:
              </p>

              <p className="text-xl font-bold text-gray-900 mb-4" data-id="element-135">
                30-peptide complexes combined with silk protein that PROTECTS
                the barrier instead of destroying it.
              </p>

              <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-136">
                This wasn't theory. This was proven in clinical trials. 94%
                efficacy rates. Visible lifting in 6-8 weeks. Zero
                irritation—even for sensitive skin.
              </p>
            </section>

            {/* The Result */}
            <section className="mb-12" data-id="element-137">
              <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-138">
                The Result? The Silk Lifting Peptide Ampoule
              </h3>

              <div className="bg-gradient-to-br from-amber-50 to-pink-50 rounded-xl p-4 md:p-8 mb-8" data-id="element-139">
                <div className="w-full max-w-3xl mx-auto mb-6" data-id="element-140">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/srAh7jBva1bicNMNT1ZmQY/before_and_after.png" alt="Before and after results showing visible skin transformation after 8 weeks" className="w-full rounded-lg shadow-lg" data-id="element-141" />
                </div>
                <p className="text-2xl font-bold text-center text-gray-900 mb-4" style={{
                fontFamily: 'Playfair Display, serif'
              }} data-id="element-142">
                  A clinical-grade formula that delivers visible lifting in 6-8
                  weeks...
                </p>
                <p className="text-xl text-center text-gray-700" data-id="element-143">
                  ...even for the most sensitive, reactive, retinol-damaged
                  skin.
                </p>
              </div>

              <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center" data-id="element-144">
                <p className="text-2xl font-bold text-gray-900 mb-2" data-id="element-145">
                  Within 8 Weeks, 94% Of Women Report Visible Results
                </p>
                <p className="text-gray-700" data-id="element-146">
                  Visible jawline lifting, softened deep wrinkles, and zero
                  irritation
                </p>
              </div>
            </section>

            {/* 3 Breakthrough Technologies */}
            <section className="mb-12" data-id="element-147">
              <h3 className="text-3xl font-bold text-gray-900 mb-8" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-148">
                The 3 Breakthrough Technologies That Make This Possible
              </h3>

              <div className="space-y-8" data-id="element-149">
                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200" data-id="element-150">
                  <h4 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-151">
                    🧬 The 30-Peptide Symphony
                  </h4>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-152">
                    Unlike Western serums with 2-3 weak peptides, this contains
                    30 different peptides working synergistically.
                  </p>
                  <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-153">
                    Think of it like the difference between a solo musician and
                    a full orchestra.
                  </p>
                  <ul className="space-y-2 ml-6" data-id="element-154">
                    <li className="text-gray-700" data-id="element-155">
                      <span className="font-semibold" data-id="element-156">Signal Peptides</span>{' '}
                      tell your skin cells: "Time to make more collagen and
                      elastin"
                    </li>
                    <li className="text-gray-700" data-id="element-157">
                      <span className="font-semibold" data-id="element-158">
                        Neurotransmitter Inhibitors
                      </span>{' '}
                      relax expression lines (like topical Botox—no needles)
                    </li>
                    <li className="text-gray-700" data-id="element-159">
                      <span className="font-semibold" data-id="element-160">Carrier Peptides</span>{' '}
                      deliver minerals and nutrients deep into skin layers
                    </li>
                    <li className="text-gray-700" data-id="element-161">
                      <span className="font-semibold" data-id="element-162">Enzyme Inhibitors</span>{' '}
                      protect your existing collagen from breaking down
                    </li>
                  </ul>
                </div>

                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200" data-id="element-163">
                  <h4 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-164">
                    🕸️ The Silk Protein Shield
                  </h4>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-165">
                    This is the breakthrough that changes everything for
                    sensitive skin.
                  </p>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-166">
                    While the peptides signal your skin to firm from within,
                    silk protein creates a protective "scaffolding" on the
                    outside.
                  </p>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-167">
                    It protects filaggrin—that crucial structural protein that
                    retinol DESTROYS.
                  </p>
                  <p className="text-gray-700 font-semibold" data-id="element-168">
                    That's why it doesn't burn. That's why it makes skin
                    stronger, not weaker.
                  </p>
                </div>

                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200" data-id="element-169">
                  <h4 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-170">
                    ✨ Gold Nanoparticle Delivery Technology
                  </h4>
                  <div className="w-full rounded-lg mb-4 overflow-hidden" data-id="element-171">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kyZXjWfYuPsg6xCQX4wCGp/GOLD_THREADS.png" alt="Close-up of gold threads in formula" className="w-full h-48 object-cover" data-id="element-172" />
                  </div>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-173">
                    Those visible gold threads floating in the bottle aren't
                    just for luxury aesthetics.
                  </p>
                  <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-174">
                    Gold nanoparticles help large peptide molecules penetrate
                    where they need to go—deep into the dermal layers where
                    collagen is produced.
                  </p>
                  <p className="text-gray-700 font-semibold" data-id="element-175">
                    The gold nanoparticle technology is what makes this formula
                    clinic-grade effective instead of just another pretty serum.
                  </p>
                </div>
              </div>
            </section>

            {/* Comparison Table */}
            <section className="mb-12" data-id="element-176">
              <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-177">
                Why Women 45-60 With Sensitive Skin Are Choosing Reliq Over
                Botox or Retinol
              </h3>

              <div className="overflow-x-auto" data-id="element-178">
                <table className="w-full bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-179">
                  <thead className="bg-gray-100" data-id="element-180">
                    <tr data-id="element-181">
                      <th className="px-4 py-3 text-left font-bold text-gray-900" data-id="element-182">
                        Factor
                      </th>
                      <th className="px-4 py-3 text-center font-bold text-gray-900" data-id="element-183">
                        Botox
                      </th>
                      <th className="px-4 py-3 text-center font-bold text-gray-900" data-id="element-184">
                        Retinol
                      </th>
                      <th className="px-4 py-3 text-center font-bold text-green-600" data-id="element-185">
                        Reliq Silk Ampoule
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-186">
                    <tr data-id="element-187">
                      <td className="px-4 py-3 font-semibold" data-id="element-188">💰 Price</td>
                      <td className="px-4 py-3 text-sm text-center" data-id="element-189">
                        $700/session every 3 months = $2,800/year
                      </td>
                      <td className="px-4 py-3 text-sm text-center" data-id="element-190">
                        $80-150/bottle
                      </td>
                      <td className="px-4 py-3 text-sm text-center bg-green-50 font-semibold" data-id="element-191">
                        Just $22.99/bottle (5-month package)
                      </td>
                    </tr>
                    <tr data-id="element-192">
                      <td className="px-4 py-3 font-semibold" data-id="element-193">⏱️ Time</td>
                      <td className="px-4 py-3 text-sm text-center" data-id="element-194">
                        Appointments, needles, 2+ hours
                      </td>
                      <td className="px-4 py-3 text-sm text-center" data-id="element-195">
                        Burns/peels for 8+ weeks
                      </td>
                      <td className="px-4 py-3 text-sm text-center bg-green-50 font-semibold" data-id="element-196">
                        2-3 drops morning/night
                      </td>
                    </tr>
                    <tr data-id="element-197">
                      <td className="px-4 py-3 font-semibold" data-id="element-198">
                        ⚠️ Side Effects
                      </td>
                      <td className="px-4 py-3 text-sm text-center" data-id="element-199">
                        Drooping, frozen look, bruising
                      </td>
                      <td className="px-4 py-3 text-sm text-center" data-id="element-200">
                        Burns, peeling, thinning
                      </td>
                      <td className="px-4 py-3 text-sm text-center bg-green-50 font-semibold" data-id="element-201">
                        Zero irritation
                      </td>
                    </tr>
                    <tr data-id="element-202">
                      <td className="px-4 py-3 font-semibold" data-id="element-203">
                        🔬 Sensitive Skin Safe?
                      </td>
                      <td className="px-4 py-3 text-sm text-center" data-id="element-204">N/A</td>
                      <td className="px-4 py-3 text-sm text-center text-red-600 font-bold" data-id="element-205">
                        ❌ Destroys sensitive skin
                      </td>
                      <td className="px-4 py-3 text-sm text-center bg-green-50 font-semibold text-green-600" data-id="element-206">
                        ✅ BUILDS barrier
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="text-center text-xl font-bold text-gray-900 mt-8" data-id="element-207">
                The choice is clear.
              </p>
            </section>

            {/* How to Use */}
            <section className="mb-12" data-id="element-208">
              <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-209">
                How to Use The Silk Lifting Peptide Ampoule in Just 30 Seconds a
                Day
              </h3>

              <div className="grid md:grid-cols-3 gap-6" data-id="element-210">
                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200 text-center" data-id="element-211">
                  <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold text-pink-600" data-id="element-212">
                    1
                  </div>
                  <h4 className="font-bold text-lg mb-2" data-id="element-213">STEP 1</h4>
                  <p className="text-gray-700 text-sm" data-id="element-214">
                    Cleanse your face with your regular gentle cleanser and pat
                    dry
                  </p>
                </div>
                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200 text-center" data-id="element-215">
                  <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold text-pink-600" data-id="element-216">
                    2
                  </div>
                  <h4 className="font-bold text-lg mb-2" data-id="element-217">STEP 2</h4>
                  <p className="text-gray-700 text-sm" data-id="element-218">
                    Apply 2-3 drops of the Silk Lifting Peptide Ampoule to your
                    face and neck, gently pressing into skin
                  </p>
                </div>
                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200 text-center" data-id="element-219">
                  <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold text-pink-600" data-id="element-220">
                    3
                  </div>
                  <h4 className="font-bold text-lg mb-2" data-id="element-221">STEP 3</h4>
                  <p className="text-gray-700 text-sm" data-id="element-222">
                    Follow with your regular moisturizer and SPF (morning) —
                    done!
                  </p>
                </div>
              </div>

              <p className="text-center text-lg text-gray-700 mt-8" data-id="element-223">
                That's it. 30 seconds. No complicated routine. No 10-step
                process.
              </p>
            </section>

            {/* Before/After Results */}
            <section className="mb-12" data-id="element-224">
              <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200" data-id="element-225">
                <div className="grid md:grid-cols-2 gap-8" data-id="element-226">
                  <div data-id="element-227">
                    <h4 className="font-bold text-xl mb-4 text-center" data-id="element-228">
                      BEFORE
                    </h4>
                    <div className="w-full h-64 rounded-lg mb-4 overflow-hidden" data-id="element-229">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i27QtwL3F1SReUoJPLo9Sy/before_.png" alt="Before using Silk Lifting Peptide Ampoule - transformation results" className="w-full h-full object-cover" data-id="element-230" />
                    </div>
                    <ul className="space-y-2 text-sm text-gray-700" data-id="element-231">
                      <li data-id="element-232">• Sagging jawline</li>
                      <li data-id="element-233">• Undefined jaw</li>
                      <li data-id="element-234">• Deep nasolabial folds</li>
                      <li data-id="element-235">• Crepey neck</li>
                    </ul>
                  </div>
                  <div data-id="element-236">
                    <h4 className="font-bold text-xl mb-4 text-center text-green-600" data-id="element-237">
                      AFTER 8 WEEKS
                    </h4>
                    <div className="w-full h-64 rounded-lg mb-4 overflow-hidden" data-id="element-238">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/g4RyycwdraMzxn2gqG39cH/after.png" alt="After 8 weeks using Silk Lifting Peptide Ampoule - transformation results" className="w-full h-full object-cover" data-id="element-239" />
                    </div>
                    <ul className="space-y-2 text-sm text-gray-700" data-id="element-240">
                      <li data-id="element-241">• Lifted jawline with visible definition</li>
                      <li data-id="element-242">• Shallower folds</li>
                      <li data-id="element-243">• Smooth neck skin</li>
                      <li data-id="element-244">• Overall "drawn upward" appearance</li>
                    </ul>
                  </div>
                </div>
                <p className="text-xs text-gray-500 text-center mt-6" data-id="element-245">
                  Results from actual customer. Individual results may vary.
                </p>
              </div>
            </section>

            {/* Testimonials */}
            <section className="mb-12" data-id="element-246">
              <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-247">
                Real Women 45-60. Real Lifting Results. Real Confidence
                Restored.
              </h3>

              <p className="text-center text-lg text-gray-700 mb-8" data-id="element-248">
                Don't just take my word for it. Here's what women with sensitive
                skin are experiencing:
              </p>

              <div className="space-y-6" data-id="element-249">
                <TestimonialCard rating={5} title="My Dermatologist Asked What I Was Using" content="I have rosacea and retinol made my face a red, peeling mess. I was skeptical anything would work for my sensitive skin—I'd been disappointed so many times. But this ampoule? Zero irritation. My jawline looks lifted after 7 weeks and my dermatologist literally asked what I was using during my checkup. She'd never seen my skin this firm AND calm at the same time. I'm 56 and I feel visible again for the first time in years." author="Jennifer M." location="Burlington, NC" data-id="element-250" />

                <TestimonialCard rating={5} title="Saved Me From $700 Botox Appointments" content="I was seriously considering Botox—$700 per session, every 3-4 months, forever. That's nearly $3,000 a year. I decided to try this first as a last-ditch effort before booking the appointment, and I'm SO glad I did. My forehead lines are softer, my skin has that 'bounce' when I press on it again, and I've saved literally thousands of dollars. Why would I do needles and risk looking frozen when this actually works and looks natural?" author="Michelle T." location="Denver, CO" data-id="element-251" />

                <TestimonialCard rating={5} title="Strangers Think I'm 15 Years Younger" content="I'm 61 and last week a barista asked if I was 'around 45-ish' when offering me a senior discount. I almost cried right there in the coffee shop. My nasolabial folds have softened dramatically—those deep lines from my nose to my mouth that made me look so tired. My neck doesn't look crepey anymore. Even my daughter noticed and asked what I changed. This is the first product that's ever actually LIFTED my face instead of just moisturizing the surface. I look in the mirror now and I see ME again." author="Patricia R." location="Las Vegas, NV" data-id="element-252" />

                <TestimonialCard rating={5} title="Finally, Something For Eczema Skin That LIFTS" content="I have eczema and every anti-aging product either burned my face or did absolutely nothing. Dermatologists told me I just had to 'accept aging gracefully' because my skin was too sensitive for real anti-aging treatments. That crushed me. But this ampoule feels like silk going on—zero reaction, no burning, no redness. And my face actually looks LIFTED after 8 weeks. I can see my jawline definition again! I'm crying happy tears writing this because I never thought I could have these results with my skin." author="Linda K." location="Hewitt, TX" data-id="element-253" />

                <TestimonialCard rating={5} title="My Husband Can't Stop Complimenting Me" content="After 3 weeks of using this, my husband said 'you look really beautiful tonight'—something I honestly hadn't heard in over 2 years. It hit me so hard I almost cried. By week 6, he was grabbing my hand in public again like when we were dating. Pulling me close in the kitchen. Actually LOOKING at me when I walked in the room. The physical changes are incredible (lifted jawline, softer lines around my mouth), but the emotional transformation—feeling SEEN again by the man I love—that's absolutely priceless. I'm 56 and I feel more attractive than I did at 45." author="Rebecca S." location="Austin, TX" data-id="element-254" />
              </div>
            </section>

            {/* Warning Section */}
            <section className="mb-12" data-id="element-255">
              <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-lg mb-8" data-id="element-256">
                <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-257">
                  ⚠️ WARNING: You Might Not See This 71% OFF Offer Again
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-258">
                  As I write this, the Silk Lifting Peptide Ampoule is flying
                  off the shelves.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-259">
                  We've already sold out 4 times in the past 6 months—each time
                  taking 3-4 weeks to restock because of the specialized
                  manufacturing process for the 30-peptide formula.
                </p>
                <p className="text-gray-700 font-bold" data-id="element-260">
                  Right now, we have inventory. But I can't guarantee for how
                  long.
                </p>
              </div>

              <div className="bg-gradient-to-r from-pink-100 to-purple-100 rounded-xl p-8 text-center" data-id="element-261">
                <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{
                fontFamily: 'Playfair Display, serif'
              }} data-id="element-262">
                  Thousands Are Joining 'The Visibility Movement'
                </h3>
                <p className="text-lg text-gray-700 mb-4" data-id="element-263">
                  Women who refuse to stay invisible. Who refuse to choose
                  between looking old and destroying their skin with retinol.
                </p>
                <p className="text-lg text-gray-700 font-semibold" data-id="element-264">
                  They're choosing a third option: lifting results WITHOUT the
                  damage.
                </p>
              </div>
            </section>

            {/* CTA 2 */}
            <div className="text-center my-12" data-id="element-265">
              <CTAButton size="large" data-id="element-266">
                👉 GET UP TO 71% OFF SILK LIFTING AMPOULE NOW
              </CTAButton>
            </div>

            {/* What Happens Next */}
            <section className="mb-12" data-id="element-267">
              <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-268">
                Here's Exactly What Happens Next:
              </h3>

              <div className="space-y-6" data-id="element-269">
                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200" data-id="element-270">
                  <h4 className="font-bold text-xl mb-2 text-gray-900" data-id="element-271">
                    1. Order Confirmation
                  </h4>
                  <p className="text-gray-700" data-id="element-272">
                    You'll receive instant email confirmation within 2 minutes
                    of placing your order
                  </p>
                </div>

                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200" data-id="element-273">
                  <h4 className="font-bold text-xl mb-2 text-gray-900" data-id="element-274">
                    2. Fast Shipping
                  </h4>
                  <p className="text-gray-700" data-id="element-275">
                    Your order ships within 2 business days via priority mail
                    (Priority Dispatch FREE with 5-Month Treatment)
                  </p>
                </div>

                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200" data-id="element-276">
                  <h4 className="font-bold text-xl mb-2 text-gray-900" data-id="element-277">
                    3. Easy Application
                  </h4>
                  <p className="text-gray-700" data-id="element-278">
                    Use 2-3 drops morning and night on clean skin—takes just 30
                    seconds
                  </p>
                </div>

                <div className="bg-white rounded-lg p-6 shadow-md border border-gray-200" data-id="element-279">
                  <h4 className="font-bold text-xl mb-2 text-gray-900" data-id="element-280">
                    4. Results Timeline
                  </h4>
                  <ul className="space-y-2 text-gray-700" data-id="element-281">
                    <li data-id="element-282">
                      <span className="font-semibold" data-id="element-283">Week 1-2:</span> Feel the
                      difference (plump, hydrated, comfortable skin)
                    </li>
                    <li data-id="element-284">
                      <span className="font-semibold" data-id="element-285">Week 6-8:</span> SEE the
                      lifting (jawline definition, softer wrinkles)
                    </li>
                    <li data-id="element-286">
                      <span className="font-semibold" data-id="element-287">Month 3+:</span> Ongoing
                      transformation (structural firming, confidence)
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Trust Badges */}
            <section className="mb-12" data-id="element-288">
              <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center" data-id="element-289">
                Remember: There Is ZERO Risk
              </h3>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-8" data-id="element-290">
                <TrustBadge icon="shield" text="60-Day Money-Back Guarantee" data-id="element-291" />
                <TrustBadge icon="dollar" text="FREE Bonuses Worth $85+" data-id="element-292" />
                <TrustBadge icon="lock" text="256-Bit Secure Checkout" data-id="element-293" />
                <TrustBadge icon="package" text="Easy Returns—Keep The Bottle" data-id="element-294" />
              </div>
            </section>

            {/* Guarantee */}
            <section className="mb-12" data-id="element-295">
              <div className="bg-green-50 border-2 border-green-500 rounded-xl p-8" data-id="element-296">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center" data-id="element-297">
                  The 60-Day "Love Your Lifted Skin or Full Refund" Guarantee
                </h3>
                <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-298">
                  Try the Silk Lifting Peptide Ampoule completely risk-free for
                  60 days.
                </p>
                <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-299">
                  Use the entire bottle. Give it the full 8 weeks. Take your
                  before-and-after photos. Watch your jawline lift. Feel your
                  skin firm.
                </p>
                <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-300">
                  If you're not thrilled with your lifted jawline, softer
                  wrinkles, and renewed confidence—we'll refund every penny.
                </p>
                <div className="bg-white rounded-lg p-4 mb-4" data-id="element-301">
                  <ul className="space-y-2" data-id="element-302">
                    <li className="flex items-center gap-2 text-gray-900" data-id="element-303">
                      <CheckIcon className="w-5 h-5 text-green-600" data-id="element-304" />
                      <span data-id="element-305">No questions asked</span>
                    </li>
                    <li className="flex items-center gap-2 text-gray-900" data-id="element-306">
                      <CheckIcon className="w-5 h-5 text-green-600" data-id="element-307" />
                      <span data-id="element-308">No hoops to jump through</span>
                    </li>
                    <li className="flex items-center gap-2 text-gray-900" data-id="element-309">
                      <CheckIcon className="w-5 h-5 text-green-600" data-id="element-310" />
                      <span data-id="element-311">Keep the bottle—we don't even want it back</span>
                    </li>
                  </ul>
                </div>
                <p className="text-xl font-bold text-gray-900 text-center" data-id="element-312">
                  Because we're betting you'll love it. And you're betting...
                  nothing.
                </p>
              </div>
            </section>

            {/* Final CTA Section */}
            <section className="mb-12" data-id="element-313">
              <div className="bg-gradient-to-r from-pink-100 to-purple-100 rounded-xl p-8 text-center" data-id="element-314">
                <h3 className="text-3xl font-bold text-gray-900 mb-6" style={{
                fontFamily: 'Playfair Display, serif'
              }} data-id="element-315">
                  Claim the Visibility and Confidence You Deserve
                </h3>

                <div className="space-y-4 mb-8 text-left max-w-2xl mx-auto" data-id="element-316">
                  <p className="text-lg text-gray-700" data-id="element-317">
                    <span className="font-bold" data-id="element-318">What would it feel like</span>{' '}
                    to catch your partner looking at you with desire again—the
                    way he did 20 years ago?
                  </p>
                  <p className="text-lg text-gray-700" data-id="element-319">
                    <span className="font-bold" data-id="element-320">What would it mean</span> to
                    walk into a restaurant and get warm, engaged eye contact
                    from strangers instead of being looked past?
                  </p>
                  <p className="text-lg text-gray-700" data-id="element-321">
                    <span className="font-bold" data-id="element-322">What would it be like</span> to
                    look in the mirror and see a vibrant, lifted, confident
                    woman staring back?
                  </p>
                </div>

                <p className="text-xl font-bold text-gray-900 mb-8" data-id="element-323">
                  Two months from now, you'll either be exactly where you are
                  today... or you'll be looking in the mirror at your lifted
                  jawline, feeling VISIBLE again.
                </p>

                <CTAButton size="large" data-id="element-324">👉 TRY THE SILK SECRET NOW</CTAButton>
              </div>
            </section>

            {/* Final Words from Dr. Kim */}
            <section className="mb-12" data-id="element-325">
              <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200" data-id="element-326">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" style={{
                fontFamily: 'Playfair Display, serif'
              }} data-id="element-327">
                  Final Words From Dr. Sarah Kim
                </h3>

                <div className="flex items-start gap-4 mb-6" data-id="element-328">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9MaiRtwtzW3QQQ3Ywdtpf3/sarah_Kim_.png" alt="Dr. Sarah Kim" className="w-24 h-24 rounded-full object-cover flex-shrink-0" data-id="element-329" />
                  <div className="text-sm text-gray-600" data-id="element-330">
                    <p className="font-semibold text-gray-900" data-id="element-331">Dr. Sarah Kim</p>
                    <p data-id="element-332">Board-Certified Dermatology Consultant</p>
                    <p data-id="element-333">Seoul National University, Department of Dermatology</p>
                    <p data-id="element-334">Founder, Reliq</p>
                  </div>
                </div>

                <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-335">
                  <p data-id="element-336">
                    I've dedicated 15 years to studying Korean skin science and
                    helping women with sensitive skin achieve the lifting
                    results they deserve—without suffering through retinol or
                    spending thousands on Botox.
                  </p>
                  <p data-id="element-337">
                    I'll never forget what one patient told me during a
                    consultation:
                  </p>
                  <p className="italic font-semibold text-lg text-gray-900 pl-4 border-l-4 border-pink-500" data-id="element-338">
                    "I don't want to be invisible anymore. I just want my
                    husband to look at me again."
                  </p>
                  <p data-id="element-339">She started crying. I started crying.</p>
                  <p data-id="element-340">Because that's not vanity. That's not superficial.</p>
                  <p className="font-bold text-gray-900" data-id="element-341">
                    That's a woman who wants to feel SEEN. Present. Valued.
                    Attractive.
                  </p>
                  <p className="font-bold text-gray-900" data-id="element-342">
                    And she deserves that. You deserve that.
                  </p>
                  <p data-id="element-343">
                    Let the Silk Lifting Peptide Ampoule be your turning point.
                  </p>
                  <p data-id="element-344">
                    Two months from now, you'll either be exactly where you are
                    today... or you'll be looking in the mirror at your lifted
                    jawline, feeling your partner's arms around you, walking
                    into rooms with your head high.
                  </p>
                  <p className="text-xl font-bold text-gray-900" data-id="element-345">
                    The choice is yours.
                  </p>
                </div>

                <div className="mt-8 text-center" data-id="element-346">
                  <p className="text-gray-700 mb-2" data-id="element-347">Yours in care,</p>
                  <p className="font-bold text-gray-900 text-lg" data-id="element-348">
                    Dr. Sarah Kim
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-349">
                    Board-Certified Dermatology Consultant
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-350">
                    Seoul National University, Department of Dermatology
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-351">Founder, Reliq</p>
                </div>
              </div>
            </section>

            {/* Final CTA */}
            <div className="text-center my-12" data-id="element-352">
              <CTAButton size="large" data-id="element-353">👉 TRY THE SILK SECRET NOW</CTAButton>
            </div>
          </main>

          {/* Sticky Sidebar - Right Side */}
          <aside className="hidden lg:block lg:col-span-4" data-id="element-354">
            <StickyProductCard data-id="element-355" />
          </aside>
        </div>
      </div>

      {/* Mobile Sticky CTA - Only visible on mobile */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg p-4" data-id="element-356">
        <CTAButton size="large" className="w-full" data-id="element-357">
          Get UP to 71% OFF SILK LIFTING AMPOULE NOW!
        </CTAButton>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12" data-id="element-358">
        <div className="max-w-7xl mx-auto px-4" data-id="element-359">
          <div className="text-center mb-8" data-id="element-360">
            <h2 className="text-2xl font-bold mb-4" style={{
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-361">
              RELIQ
            </h2>
          </div>

          <div className="flex flex-wrap justify-center gap-4 mb-8 text-sm" data-id="element-362">
            <a href="#" className="hover:text-pink-400 transition-colors" data-id="element-363">
              Imprint
            </a>
            <span data-id="element-364">|</span>
            <a href="https://tryreliq.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-pink-400 transition-colors" data-id="element-365">
              Privacy Policy
            </a>
            <span data-id="element-366">|</span>
            <a href="https://tryreliq.com/policies/terms-of-service" target="_blank" rel="noopener noreferrer" className="hover:text-pink-400 transition-colors" data-id="element-367">
              Terms & Conditions
            </a>
            <span data-id="element-368">|</span>
            <a href="https://tryreliq.com/pages/contact" target="_blank" rel="noopener noreferrer" className="hover:text-pink-400 transition-colors" data-id="element-369">
              Contact Us
            </a>
            <span data-id="element-370">|</span>
            <a href="#" className="hover:text-pink-400 transition-colors" data-id="element-371">
              Shipping Information
            </a>
          </div>

          <div className="text-xs text-gray-400 space-y-4" data-id="element-372">
            <p className="font-bold" data-id="element-373">DISCLAIMERS:</p>
            <p data-id="element-374">
              These statements have not been evaluated by the Food and Drug
              Administration. This product is not intended to diagnose, treat,
              cure, or prevent any disease. Results may vary from person to
              person. Individual results will depend on skin type, condition,
              age, and other factors. Testimonials are from real customers but
              may not represent typical results. Before-and-after images are
              from actual customers who used the product as directed. Always
              consult with a healthcare professional before starting any new
              skincare regimen.
            </p>
            <p data-id="element-375">
              Individual results may vary, testimonials are not claimed to
              represent typical results. Results shown may not reflect the
              typical user's experience, and are not intended to represent or
              guarantee that anyone will achieve the same or similar results.
            </p>
            <p className="text-center mt-8" data-id="element-376">
              © 2024 Reliq. All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}